import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { ContentCopy as ContentCopyIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const ResourceNameCell = ({ value, showCopy = true }) => {
  const theme = useTheme();
  const textValue = value || "-";

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Tooltip title={textValue !== "-" ? textValue : ""} arrow placement="top">
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 500, 
            fontSize: "0.8125rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1
          }}
        >
          {textValue}
        </Typography>
      </Tooltip>
      {showCopy && textValue !== "-" && (
        <Tooltip title="Copy to clipboard" arrow>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleCopyToClipboard(textValue);
            }}
            sx={{
              padding: 0.5,
              opacity: 0.6,
              "&:hover": {
                opacity: 1,
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <ContentCopyIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ResourceNameCell;

